import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";
import { QueryParams } from "@/models/query-params.model";
import { Denounce } from "@/models/denounce.model";

export class TopicsRest {
  getAllTopics(params?: QueryParams): Observable<any> {
    const url: string = "/topics";
    return api.get(url, params);
  }
  deleteTopic(topicId: string): Observable<any> {
    const url: string = `/topics/${topicId}`;
    return api.delete(url);
  }
  createTopic(formData: FormData): Observable<any> {
    const url: string = "/topics";
    return api.post(url, formData);
  }
  getTopicById(topicId: string): Observable<any> {
    const url: string = `/topics/${topicId}`;
    return api.get(url);
  }

  updateTopic(topicId, formData: FormData): Observable<any> {
    const url: string = `/topics/${topicId}`;
    return api.put(url, formData);
  }

  likeTopic(id: string) {
    const url: string = `/topics/${id}/like`;
    return api.post(url, {});
  }

  denunceTopic(id: string, denounce: Denounce) {
    const url: string = `/topics/${id}/denounces`;
    return api.post(url, denounce);
  }

  getAllDenouncesTopic(params: QueryParams): Observable<any> {
    const url: string = `/topics/denounces`;
    return api.get(url, params);
  }
  updateTopicDenounce(topicId: string, denounces: Array<Denounce>): Observable<any> {
    const url: string = `/topics/${topicId}/denounces`;
    return api.patch(url, denounces);
  }
    
}
